<template>
    <div>
        <PreviewModal ref="preview_modal"></PreviewModal>
        <div class="table-listings">
            <el-table 
                ref="multipleTable"
                v-loading="isTableLoading"
                :data="customer_documents"
                style="width: 100%;"
				@selection-change="selectDocuments"
            >
                <el-table-column
                    type="selection"
                    width="55"
                    height="500"
                ></el-table-column>

                <el-table-column
                    prop="file_name"
                    label="File Name / Category"
                    sortable
                    min-width="180"
                >
                    <template slot-scope="scope">
                        <a 
                            href="javascript:void(0)" 
                            @click="$refs.preview_modal.preview(
                                scope.row.url, 
                                scope.row.display_filename
                            )" 
                            class="text-truncate mr-2"
                        >{{ scope.row.display_filename }}</a>
                    </template>
                </el-table-column>

                <el-table-column
                    prop="updated_date"
                    label="Updated Date"
                    sortable
                >
                    <template slot-scope="scope">
                        <p class="">{{ scope.row.updated_at | dateFormatString }}</p>
                    </template>
                </el-table-column>
            </el-table>
        </div>
		<div class="my-3 d-flex justify-content-end">
			<el-button class="bg-primary text-white w-30 mb-3 text-end" :loading="is_loading" @click="submitDocuments" :disabled="selectedDocs.length == 0">Submit to Solicitor</el-button>
		</div>

		<SubmitDocumentModal :show_documents.sync="modals.submit" 
		ref="customerDocuments" 
		@close="toggleSubmitQuotation"  
		:selected_documents="selectedDocs" 
		 :product_id="product_id"/>

    </div>
</template>

<script>
import Modal from "@/components/Modal"
import { Select, DatePicker,  Option, Collapse, CollapseItem, Table, TableColumn, Button  } from 'element-ui'
import {
	notifyFunctionMixin,
	axios,
	services,
	getHeader,
	helperFunctionMixin
} from '@/assets/js/httpImports.js'
import { integer } from 'vee-validate/dist/rules'
import PreviewModal  from '@/components/Modal/PreviewModal'
import { useProductStore } from '@/stores/productStore'
import { mapState, mapActions } from 'pinia'
import caseEventBus from '@/assets/js/EventBus/caseEventBus.js'
import SubmitDocumentModal from "@/views/CustomerProfile/CustomerProfileDetails/CenterProfileDetails/CasesCards/SolicitorCase/Modals/SubmitDocumentModal.vue"

export default {
	props:{
		show_documents: Boolean,
		customer_id: integer,
		product_id: integer,
		product_type: String, // Changed from object to String
	},
	mixins: [notifyFunctionMixin, helperFunctionMixin],
	components: {
		PreviewModal,
		Modal,
		[DatePicker.name]: DatePicker,
		[Collapse.name]: Collapse,
		[Option.name]: Option,
		[CollapseItem.name]: CollapseItem,
		[Select.name]: Select,
		[Table.name]: Table,
		[TableColumn.name]: TableColumn,
		[Button.name]: Button,
		SubmitDocumentModal
	},
	computed: {
		show: {
			get() {
				return this.show_documents;
			},
			set(newVal) {
				this.$emit('update:show_documents', newVal);
			},
		},
		customerDocuments(){
			if(this.searchQuery === ''){
				return this.customer_documents
			}
			return this.customer_documents.filter((document) => {
				let search = this.searchQuery.toLowerCase()
				if(
					document.original_filename.toLowerCase().includes(search) || 
					(document.attachment_category && document.attachment_category.name.toLowerCase().includes(search))
				){
					return true
				}
				return false
			})
		}
	},

	mounted() {
		if (this.customer_id) {
			this.getCustomerAttachments();
		}
	},

	data() {
		return {
			isTableLoading: false,
			is_loading: false,
			searchQuery: '',
			date_picked: '',
			doc_check: '',
			customer_documents:[],
			activeNames:['1'],
			selected_documents: [],
			is_loading_submit: false,
			selectedLawyer: '',
			lawyerOptions: [
				{ text: 'Mr. Lim', value: 'Mr. Lim' }
			],
			modals: {
				submit: false
			},
			selectedDocs: []
		}
	},

	methods:{
		...mapActions(useProductStore, ['submitSolicitorDocuments']),

		getCustomerAttachments(){
			axios.get(services.customer + 'customer/' + this.customer_id +'/attachments.all', {headers: getHeader()})
				.then(res => {
					this.customer_documents = res.data.data
					for(let x = 0; x < this.customer_documents.length; x++){ 
						const document = this.customer_documents[x]
						document.display_filename = document.attachment_category ? 
							document.attachment_category.name + ' - ' + document.original_filename : 
							document.original_filename
					}
				})
			.catch(e => {
				this.errorFunction(e)
			})
		},

		async submitDocuments(){
      		try{
				const formattedDocuments = this.customer_documents.map(document => ({
				doc_attach_id: document.attachment_id,
				doc_file_name: document.original_filename,
				doc_file_path: document.path, // Assuming `path` is the correct field for the document path
				doc_prod_id: this.product_id,
				doc_prod_type: this.product_type
			}));

			const formData = {
			documents: formattedDocuments
			};

        	// Submit the data
        	this.is_loading_submit = true;
			await this.submitSolicitorDocuments(formData, 'solicitor');
				// axios.post(services.product   + 'product-documents', formData, { headers: getHeader() })
				// .then(res => {
					this.notifySuccess('<b>Documents</b> - Successfully Submitted.');
					this.$refs.customerDocuments.$emit("updateSelectedDocuments", {
              			selectedDocs: this.selectedDocs,
              			product_id: this.product_id,
          			});
					this.$emit('update:show_documents', false);
					this.is_loading_submit = false;
					this.toggleSubmitQuotation();
				// })
			}
			catch (e) {  
				// .catch(e => {
					this.is_loading_submit = false;
					this.errorFunction(e);
				// });
			}
      	},

		async toggleSubmitQuotation() {
			this.modals.submit = !this.modals.submit
		},

		selectDocuments($event) {
			this.selectedDocs = $event
		}
	}
}
</script>